// import React from 'react';
// import Checkbox from '@material-ui/core/Checkbox';
// import Component from 'mson/lib/component';
// import FormControlLabel from '@material-ui/core/FormControlLabel';

import attach from "mson-react/lib/attach";

import { FunctionComponent, useContext, useEffect } from "react";
import { AuthContext, AuthContextValue } from "../../contexts/AuthContext";

interface AuthStatusProps {
  component: any;
  value: AuthContextValue;
}

export const AuthStatus: FunctionComponent<AuthStatusProps> = ({
  component,
}: AuthStatusProps) => {
  const authState = useContext(AuthContext);

  useEffect(() => {
    component.setValue(authState);
  }, [authState, component]);
  return null;
};

const returnValue = attach(["value"])(AuthStatus);

export default returnValue;
